export default __webpack_public_path__ + "static/media/land_loans.0947b2ad.jpg";